import { ActionType } from '@/actions';
import { ActionSetCurrentCouponId } from './interfaces';

export function setCurrentCouponId(
  game: number,
  currentCouponId: number
): ActionSetCurrentCouponId {
  return {
    type: ActionType.CURRENT_COUPON_ID_SET,
    game,
    currentCouponId,
  };
}
